import D2C_TariffPlan from './Plan'

class D2C_TariffBusiness extends D2C_TariffPlan {
  icon = 'users'
  isBusiness = true
  static objectType = 'tariffType'
  static active = false
  static tariffId = '5b6d7dc6bf716bde9a2217ff'
  static tariffTitle = 'Business'
  static order = 40
}

export default D2C_TariffBusiness
